// extracted by mini-css-extract-plugin
export default {"header-btn":"CloseModalBtn_header-btn__Q3lmE"};